import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

// Add the shine animation keyframes
const shine = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(200%); }
`;

// Create a styled component for the shine effect
const ButtonShine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 50%;
  animation: ${shine} 1.8s linear infinite;
  background: linear-gradient(
    to right,
    transparent,
    rgba(255, 255, 255, 0.8),
    transparent
  );
`;

const OfferwallPage = ({ username }) => {
  const [showCard, setShowCard] = useState(false);
  const [appId, setAppId] = useState("85735839");
  const blacklist = ["demotest", "demo3w"];

  useEffect(() => {
    const isBusinessDomain = window.location.hostname === "business.taskplanet.org";
    setAppId(isBusinessDomain ? "92044228" : "85735839");
    if (username && !blacklist.includes(username)) {
      setShowCard(true);
    }
  }, [username]);

  const handleClick = () => {
    const url = `https://wow.pubscale.com?app_id=${appId}&user_id=${username}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (!showCard) return null;

  return (
    <div style={styles.cardContainer}>
      <div style={styles.trendingTag}>
        <span style={styles.trendingText}>TRENDING</span>
      </div>

      <div style={styles.animatedBorder}>
        <div style={styles.referralCard}>
          <div style={styles.referralContent}>
            <div style={styles.referralHeader}>
              <img
                src="https://res.cloudinary.com/dztzqhifb/image/upload/v1747804874/ny3f7rmazixfowkcw1ig.png"
                style={styles.referralIcon}
                alt="Offerwall"
              />
              <span style={styles.referralLabel}>
                Earn Up to 10,00,000 Points/Month!
              </span>
            </div>
            <h3 style={styles.referralTitle}>
              Complete Tasks and Boost your Leaderboard Rank and Earning instantly.
            </h3>
            <p style={styles.referralDescriptionText}>
              From Sign up, surveys to app installs — Get instant rewards!
            </p>
            
            <button 
              onClick={handleClick}
              style={styles.referralPrimaryButton}
            >
              <ButtonShine />
              <span style={styles.referralButtonText}>Start Earning</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  cardContainer: {
    marginBottom: "11px",
    marginLeft: "13px",
    marginRight: "13px",
    position: "relative",
    marginTop: "7px",
    maxWidth: "600px",
  },
  animatedBorder: {
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: "#FFB300",
    borderRadius: "14px",
    overflow: "hidden",
    animation: "borderPulse 2s infinite linear",
  },
  trendingTag: {
    position: "absolute",
    top: "-10px",
    right: "10px",
    backgroundColor: "#FF5722",
    padding: "3px 8px",
    borderRadius: "12px",
    zIndex: "10",
    boxShadow: "0 2px 5px rgba(0,0,0,0.25)",
    animation: "tagPop 0.6s ease-out",
  },
  trendingText: {
    color: "white",
    fontWeight: "bold",
    fontSize: "10px",
    textTransform: "uppercase",
  },
  referralCard: {
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 5px 10px rgba(0,0,0,0.1)",
    background: "linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)",
  },
  referralContent: {
    display: "flex",
    flexDirection: "column",
  },
  referralHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
  },
  referralIcon: {
    width: "28px",
    height: "28px",
    marginRight: "3px",
    objectFit: "contain",
  },
  referralLabel: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#E65100",
  },
  referralTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#333",
    marginBottom: "1px",
    marginTop: "0",
  },
  referralDescriptionText: {
    fontSize: "10.5px",
    color: "#555",
    marginBottom: "4px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  referralPrimaryButton: {
    display: "flex",
    backgroundColor: "#FFB300",
    borderRadius: "6px",
    padding: "7px 20px",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    marginTop: "8px",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  referralButtonText: {
    color: "#FFFFFF",
    fontWeight: "600",
    fontSize: "16px",
    marginRight: "8px",
    zIndex: "1",
  },
  "@keyframes borderPulse": {
    "0%": { borderColor: "#FFB300" },
    "50%": { borderColor: "#F9A825" },
    "100%": { borderColor: "#FFB300" },
  },
  "@keyframes tagPop": {
    "0%": { transform: "scale(0.8) translateY(-20px)", opacity: "0" },
    "80%": { transform: "scale(1.1) translateY(0)", opacity: "1" },
    "100%": { transform: "scale(1) translateY(0)", opacity: "1" },
  },
};

export default OfferwallPage;